import React from 'react';
import bijouxImage from '../../images/bijoux.PNG';
import CategoryPage from '../CategoryPage';
import { CATEGORIES_SEO } from '../../seo/pagesSeo';

function BijouxPage() {
    const seo = CATEGORIES_SEO.bijoux;
    const details = [
        'Bagues anciennes',
        'Colliers et pendentifs',
        'Bracelets et manchettes',
        'Broches et épingles',
        'Pendants d’oreilles',
        'Montres de luxe serties',
        'Bijoux en or, platine, et argent',
        'Pierres précieuses : diamants, rubis, émeraudes, et saphirs',
        'Créations signées par de grands joailliers',
    ];

    const description = `
En tant qu'antiquaire, je me consacre à l'acquisition de joaillerie ancienne, même en état imparfait, tout en garantissant une évaluation raffinée et professionnelle.

L'histoire et l'émotion qui se cachent derrière chaque objet. Chaque pièce est unique et mérite d'être reconnue à sa juste valeur. Que vous souhaitiez vendre une montre, un pendentif contemporain, collier de perles, mon expertise me permet d'évaluer vos joaillerie ancienne avec soin.

Types de joaillerie ancienne : Colliers, Bracelets, Boucles d'oreilles, Bagues, Broches, Joaillerie de cheville, Joaillerie de tête, Montres, Pendentifs, Brossettes, Épingles, Joaillerie pour hommes, Joaillerie en verre, Joaillerie en métal, Joaillerie ethnique, Joaillerie artisanale.
    `;

    return (
        <CategoryPage
            title="Bijoux"
            image={bijouxImage}
            description={description}
            details={details}
            seoTitle={seo.title}
            seoDescription={seo.description}
            seoPath={seo.path}
        />
    );
}

export default BijouxPage;
